function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import PropTypes from 'prop-types';
import React from 'react';
import Icon from '../../common/containers/icon';
import SearchInput from '../../common/search/searchInput';
const FillFromPreviousButtonHeader = ({
  jobIndexQuery,
  jobServerFilter,
  selectedJob: _selectedJob = '',
  selectedSource: _selectedSource = '',
  setSelectedJob,
  setSelectedSource,
  sources: _sources = [],
  showBack: _showBack = true
}) => {
  const {
    filters
  } = jobIndexQuery;
  const handleSearch = value => {
    jobServerFilter(_objectSpread(_objectSpread({}, filters), {}, {
      text: value
    }), jobIndexQuery);
  };
  const clearSearch = () => {
    handleSearch(null);
  };
  let result = '';
  if (!_showBack) {
    result = /*#__PURE__*/React.createElement("div", {
      style: {
        outline: 'none',
        textAlign: 'left'
      }
    }, "Select a Report");
  } else if (!_selectedJob) {
    result = /*#__PURE__*/React.createElement("div", {
      style: {
        outline: 'none',
        textAlign: 'left'
      }
    }, "Select a Job", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(SearchInput, {
      size: "sm",
      onChange: handleSearch,
      text: filters && filters.text || null,
      onClear: clearSearch
    }));
  } else if (_sources && _sources.length && !_selectedSource) {
    result = /*#__PURE__*/React.createElement("div", {
      className: "fade-in t-ffpb-back",
      onClick: () => setSelectedJob(null),
      onKeyPress: () => setSelectedJob(null),
      role: "link",
      tabIndex: 0,
      style: {
        outline: 'none',
        cursor: 'pointer',
        textAlign: 'left'
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      glyph: "angle-left"
    }), " Back");
  } else if (_selectedSource) {
    result = /*#__PURE__*/React.createElement("div", {
      className: "fade-in t-ffpb-back",
      onClick: () => setSelectedSource(null),
      onKeyPress: () => setSelectedSource(null),
      role: "link",
      tabIndex: 0,
      style: {
        outline: 'none',
        cursor: 'pointer',
        textAlign: 'left'
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      glyph: "angle-left"
    }), " Back");
  } else if (_selectedJob) {
    result = /*#__PURE__*/React.createElement("div", {
      className: "fade-in t-ffpb-back",
      onClick: () => setSelectedJob(null),
      onKeyPress: () => setSelectedJob(null),
      role: "link",
      tabIndex: 0,
      style: {
        outline: 'none',
        cursor: 'pointer',
        textAlign: 'left'
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      glyph: "angle-left"
    }), " Back");
  }
  return result;
};
FillFromPreviousButtonHeader.propTypes = {
  jobIndexQuery: PropTypes.shape({}).isRequired,
  jobServerFilter: PropTypes.func.isRequired,
  selectedJob: PropTypes.string,
  selectedSource: PropTypes.shape({}),
  setSelectedJob: PropTypes.func.isRequired,
  setSelectedSource: PropTypes.func.isRequired,
  sources: PropTypes.arrayOf(PropTypes.shape({})),
  showBack: PropTypes.bool
};
export default FillFromPreviousButtonHeader;